import { useSearchParams } from "react-router";

export const SERVICE_LIST = [
  "alarms",
  "assets",
  "authentication",
  "cases",
  "componentadmin",
  "configurationadmin",
  "currentuser",
  "customernetworks",
  "customers",
  "datastores",
  "documents",
  "eventfilters",
  "events",
  "geoip",
  "jsonobject",
  "metrics",
  "notification",
  "pdns",
  "reputation",
  "sampledb",
  "sensors",
  "signatures",
  "users",
  "world",
] as const;

export const API_STATUS_LIST = ["PUBLIC", "INTERNAL", "DEV", "ALL"] as const;

export const DEFAULT_API_STATUS: TAPIStatusList = "PUBLIC";

export type TServiceList = (typeof SERVICE_LIST)[number];
export type TAPIStatusList = (typeof API_STATUS_LIST)[number];

type TUrlParams = {
  module?: TServiceList;
  apistatus?: TAPIStatusList;
};

/* This hook is wrapping react-router's hook to achieve better typing and to make it easier to update url parameters */
export const useUrlParams = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const urlParams = Object.fromEntries(searchParams) as TUrlParams;

  const removeUrlParam = (urlParam: keyof TUrlParams) =>
    setSearchParams((searchParams) => {
      searchParams.delete(urlParam);
      return searchParams;
    });

  const updateUrlParams = (urlParams: TUrlParams) =>
    setSearchParams({ ...Object.fromEntries(searchParams), ...urlParams });

  return { urlParams, updateUrlParams, removeUrlParam };
};
